import { Expose } from 'class-transformer';

export default class CustomEmailError {
  recipient_type: string[] = []
  recipient_id: string[] = []
  subject: string[] = []
  body: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}